import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguageData } from '../../hooks/useLanguageData';

function Membre_equipe_diplo() {
  const { t } = useTranslation();
  const [teamMembers, setTeamMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Utiliser l'API members avec traduction automatique
  const {
    data: membersResponse,
    loading: membersLoading,
    error: membersError
  } = useLanguageData('/api/v1/embassy/members');

  // Transformer les données quand elles arrivent
  useEffect(() => {
    if (membersResponse?.data && Array.isArray(membersResponse.data)) {
      console.log("🔍 Données API membres (avec langue):", membersResponse);

      // Transformer les données de l'API members
      const allMembers = membersResponse.data.map(member => ({
        name: member.name || t('common.nameNotAvailable'),
        title: member.poste || member.poste1 || t('common.positionNotSpecified'),
        image: member.picture || null,
        linkedin: member.socialLinkedIn && member.socialLinkedIn !== "..." && member.socialLinkedIn !== null ? member.socialLinkedIn : "#",
        twitter: member.socialTwitter && member.socialTwitter !== "..." && member.socialTwitter !== null ? member.socialTwitter : "#",
        category: member.category || '',
        dateStart: member.dateStartAppointment?.date,
        dateEnd: member.dateEndAppointment?.date,
        mission: member.mission || member.bibliography || '' // Récupérer la bibliographie/mission
      }));

      console.log("👥 Membres transformés:", allMembers);
      setTeamMembers(allMembers);
    }
  }, [membersResponse, t]);

  // Ouvrir le modal avec le membre sélectionné
  const openModal = (member) => {
    setSelectedMember(member);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden'; // Empêcher le scroll
  };

  // Fermer le modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMember(null);
    document.body.style.overflow = 'unset'; // Réactiver le scroll
  };

  // Fermer le modal avec la touche Echap
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  // Composant de spinner de chargement
  const LoadingSpinner = () => (
    <div className="section-home-team" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px'
    }}>
      <div style={{
        width: "40px",
        height: "40px",
        border: "3px solid #f3f3f3",
        borderTop: "3px solid #1a3c5e",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}></div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );

  if (membersLoading) {
    return <LoadingSpinner />;
  }

  if (membersError || teamMembers.length === 0) {
    return (
      <div className="section-home-team" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          {t('team.noMembers')}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="section-home-team">
        {teamMembers.map((member, index) => (
          <div
            className="one-person"
            key={index}
            onClick={() => openModal(member)}
            style={{ cursor: 'pointer' }}
          >
            {member.image ? (
              <img
                src={member.image}
                alt={member.name}
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            ) : (
              <div className="no-image-placeholder">
                <span>👤</span>
              </div>
            )}
            <div className="info">
              <div className="name">{member.name}</div>
              <div className="poste">{member.title}</div>

              <div className="socials">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                  className={member.linkedin === "#" ? "social-link-disabled" : ""}
                  onClick={(e) => e.stopPropagation()} // Empêcher l'ouverture du modal
                >
                  <i className="fi fi-brands-linkedin"></i>
                </a>
                <a
                  href={member.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                  className={member.twitter === "#" ? "social-link-disabled" : ""}
                  onClick={(e) => e.stopPropagation()} // Empêcher l'ouverture du modal
                >
                  <i className="fi fi-brands-twitter-alt-circle"></i>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedMember && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <i className="fa fa-times"></i>
            </button>

            <div className="modal-header">
              {selectedMember.image ? (
                <img
                  src={selectedMember.image}
                  alt={selectedMember.name}
                  className="modal-image"
                />
              ) : (
                <div className="modal-image-placeholder">
                  <span>👤</span>
                </div>
              )}
              <div className="modal-header-info">
                <h2 className="modal-name">{selectedMember.name}</h2>
                <h3 className="modal-title">{selectedMember.title}</h3>

                <div className="modal-social-icons">
                  {selectedMember.linkedin  && (
                    <a
                      href={selectedMember.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="modal-social-icon"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="fi fi-brands-linkedin"></i>
                    </a>
                  )}
                  {selectedMember.twitter  && (
                    <a
                      href={selectedMember.twitter}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="modal-social-icon"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="fi fi-brands-twitter-alt-circle"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-body">
              {selectedMember.mission ? (
                <div className="modal-bibliography">
                  <h4 className="bibliography-title">{t('team.bibliography')}</h4>
                  <div
                    className="bibliography-content"
                    dangerouslySetInnerHTML={{ __html: selectedMember.mission }}
                  />
                </div>
              ) : (
                <p className="no-bibliography">{t('team.noBibliography')}</p>
              )}
            </div>

            {/* <div className="modal-footer">
              <div className="modal-socials">
                {selectedMember.linkedin && selectedMember.linkedin !== "#" && (
                  <a 
                    href={selectedMember.linkedin} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="modal-social-link"
                  >
                    <i className="fi fi-brands-linkedin"></i>
                  </a>
                )}
                {selectedMember.twitter && selectedMember.twitter !== "#" && (
                  <a 
                    href={selectedMember.twitter} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="modal-social-link"
                  >
                    <i className="fi fi-brands-twitter-alt-circle"></i>
                  </a>
                )}
              </div>
            </div> */}
          </div>
        </div>
      )}

      <style>
        {`
          /* Styles du modal */
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.7);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            animation: fadeIn 0.3s ease;
            padding: 20px;
          }

          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }

          @keyframes slideUp {
            from { 
              transform: translateY(50px);
              opacity: 0;
            }
            to { 
              transform: translateY(0);
              opacity: 1;
            }
          }

          .modal-content {
            background: white;
            border-radius: 12px;
            max-width: 1200px;
            width: 100%;
            max-height: 90vh;
            overflow-y: auto;
            position: relative;
            animation: slideUp 0.3s ease;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          }

          .modal-close {
            position: absolute;
            top: 15px;
            right: 15px;
            background: rgba(10, 44, 87, 0.1);
            border: none;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            font-size: 20px;
            cursor: pointer;
            transition: all 0.3s ease;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .modal-close i {
            color: #0a2c57; /* Couleur de la croix */
            font-size: 20px;
          }

          .modal-close:hover {
            background: #de2910; /* Fond rouge au survol */
          }

          .modal-close:hover i {
            color: white; /* Croix blanche au survol */
          }

          .modal-header {
            display: flex;
            gap: 25px;
            padding: 30px 30px 0px 30px;
           
            align-items: end;
          }

          .modal-image {
            width: 100px;
            
            
            object-fit: container;
            
            flex-shrink: 0;
          }

          .modal-image-placeholder {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: #f0f0f0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 60px;
            border: 4px solid #0a2c57;
            flex-shrink: 0;
          }

          .modal-header-info {
            flex: 1;
            text-align:left
          }

          .modal-name {
            font-size: 24px;
            font-weight: bold;
            color: #0a2c57;
            margin: 0 0 5px 0;
          }

          .modal-title {
            font-size: 18px;
            color: #666;
            margin: 0 0 10px 0;
            font-weight: 500;
          }

          .modal-dates {
            font-size: 14px;
            color: #999;
            margin-top: 5px;
          }

          .modal-body {
            padding: 30px;
            margin-top: -10px
          }

          .modal-bibliography {
            background: #f8f9fa;
            border-radius: 8px;
            padding: 20px;
            text-align: justify
          }

          .bibliography-title {
            font-size: 18px;
            font-weight: bold;
            color: #0a2c57;
            margin: 0 0 15px 0;
            border-bottom: 2px solid #de2910;
            padding-bottom: 10px;
          }

          .bibliography-content {
            font-size: 16px;
            line-height: 1.8;
            color: #333;
          }

          .bibliography-content p {
            margin-bottom: 15px;
          }

          .bibliography-content ul {
            padding-left: 20px;
            margin-bottom: 15px;
          }

          .bibliography-content li {
            margin-bottom: 8px;
          }

          .no-bibliography {
            color: #999;
            font-size: 16px;
            text-align: center;
            padding: 20px;
          }

          .modal-footer {
            padding: 20px 30px 30px 30px;
            border-top: 2px solid #f0f0f0;
          }

          .modal-socials {
            display: flex;
            gap: 15px;
            justify-content: center;
          }

          .modal-social-link {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background: #0a2c57;
            color: white;
            font-size: 22px;
            transition: all 0.3s ease;
            text-decoration: none;
          }

          .modal-social-link:hover {
            background: #ffd400;
            color: #0a2c57;
            transform: translateY(-3px);
            box-shadow: 0 5px 15px rgba(10, 44, 87, 0.2);
          }

          /* Responsive modal */
          @media (max-width: 768px) {
            .modal-content {
              max-width: 95%;
              max-height: 95vh;
            }

            .modal-header {
              flex-direction: column;
              text-align: center;
              padding: 20px;
              align-items: start;
              
            }

            .modal-header-info {
              align-content: end
            }

            .modal-image,
            .modal-image-placeholder {
              width: 100px;
              height: 126px;
            }

            .modal-name {
              font-size: 20px;
            }

            .modal-title {
              font-size: 16px;
            }

            .modal-body {
              padding: 20px;
            }

            .modal-bibliography {
              padding: 15px;
            }

            .bibliography-content {
              font-size: 15px;
            }
          }

          @media (max-width: 480px) {
            .modal-content {
              max-width: 98%;
              max-height: 98vh;
            }

            .modal-header {
              padding: 15px;
              align-items: start;
              
            }

            .modal-image,
            .modal-image-placeholder {
              width: 80px;
              height: 100px;
              margin-bottom: -10px
            }

            .modal-name {
              font-size: 18px;
            }

            .modal-title {
              font-size: 14px;
            }

            .modal-body {
              padding: 15px;
            }

            .bibliography-content {
              font-size: 14px;
            }

            .modal-close {
              top: 10px;
              right: 10px;
              width: 35px;
              height: 35px;
              font-size: 16px;
            }
          }

          /* Animation de scroll personnalisée pour le modal */
          .modal-content::-webkit-scrollbar {
            width: 8px;
          }

          .modal-content::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }

          .modal-content::-webkit-scrollbar-thumb {
            background: #0a2c57;
            border-radius: 10px;
          }

          .modal-content::-webkit-scrollbar-thumb:hover {
            background: #de2910;
          }

          .modal-social-icons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.modal-social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #0a2c57;
  color: white;
  font-size: 18px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.modal-social-icon:hover {
  background: #ffd400;
  color: #0a2c57;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(10, 44, 87, 0.2);
}

/* Forcer l'affichage des icônes Flaticon dans le modal */
.modal-social-icon .fi,
.modal-social-icon .fi-brands-linkedin,
.modal-social-icon .fi-brands-twitter-alt-circle {
  font-size: 20px !important;
  color: white !important;
  display: inline-block !important;
}

.modal-social-icon:hover .fi,
.modal-social-icon:hover .fi-brands-linkedin,
.modal-social-icon:hover .fi-brands-twitter-alt-circle {
  color: #0a2c57 !important;
}

.modal-social-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #0a2c57;
  color: white;
  font-size: 18px;
  transition: all 0.3s ease;
  text-decoration: none;
  /* AJOUTEZ CES LIGNES */
  line-height: 1;
  text-align: center;
  vertical-align: middle;
}

.modal-social-icon .fi,
.modal-social-icon .fi-brands-linkedin,
.modal-social-icon .fi-brands-twitter-alt-circle {
  font-size: 18px !important;
  color: white !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  line-height: 1 !important;
  width: 100%;
  height: 100%;
}

/* Correction spécifique pour l'icône Twitter */
.modal-social-icon .fi-brands-twitter-alt-circle {
  font-size: 20px !important;
}
        `}
      </style>
    </>
  );
}

export default Membre_equipe_diplo;